import React from 'react';
import { StyleSheet, SafeAreaView } from 'react-native';
import { Color } from '../../styles';

const WrapBottomColor = ({ style, disabled, ...rest }) => {
  return (
    <>
      <SafeAreaView style={styles.container0} />
      <SafeAreaView
        style={[styles.container, disabled ? styles.containerDisabled : null, style]}
        {...rest}
      />
    </>
  );
};

const styles = StyleSheet.create({
  container0: {
    flex: 0,
    backgroundColor: Color.accent,
  },
  container: {
    flex: 1,
    backgroundColor: Color.primary,
  },
  containerDisabled: {
    backgroundColor: Color.disabled,
  },
});

export default WrapBottomColor;
